module.exports = __webpack_public_path__ + "media/application/images/svgs/fast-forward-0fd1a8cf6c30ff5287c5b6e18c49078d.svg";